import { LifecycleStoreTransition } from '@/store/Lifecycle/types';
import { Stage } from '@/store/Station/constants';

export interface TransitionWithSkippedStages extends LifecycleStoreTransition {
  skippedStages: string[];
}

export const sortTransitionsWithSkippedStages = (
  transitions: LifecycleStoreTransition[],
  stages: Stage[]
): TransitionWithSkippedStages[] => {
  if (!transitions?.length) return [];

  const stageOrderMap = new Map(stages.map((stage) => [stage.id, stage.order]));
  const stageNameMap = new Map(stages.map((stage) => [stage.id, stage.name]));

  const sorted = [...transitions]
    .filter((transition) => transition.isActive)
    .sort((a, b) => {
      const orderA = stageOrderMap.get(a.id) ?? Infinity;
      const orderB = stageOrderMap.get(b.id) ?? Infinity;
      return orderA - orderB;
    });

  return sorted.map((transition, index) => {
    const skippedStages =
      index > 0
        ? sorted.slice(0, index).map((t) => stageNameMap.get(t.id) || t.name)
        : [];

    return {
      ...transition,
      skippedStages,
    };
  });
};

